'use strict';

import { initGoogleMaps } from '@jf-neos-googlemaps/index.js';
import { initBootstrap } from './bootstrap/index.js';
import { initForms } from './forms/index.js';
import { initPerformance } from './performance/index.js';

// Empêche le navigateur de sauter à l’ancre avant l’init Lenis.
if (window.location.hash && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

function prefersReducedMotion() {
    return (
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
}

// Démarrer le téléchargement dès l’évaluation du script (léger retard vs attente DOMContentLoaded),
// puis n’initialiser Lenis/GSAP une fois le DOM prêt.
const motionModulePromise = prefersReducedMotion()
    ? null
    : import(
        /* webpackChunkName: "motion" */
        /* webpackMode: "lazy" */
        './deferred-motion.js'
    );

document.addEventListener('DOMContentLoaded', () => {
    initPerformance();
    initBootstrap();
    initForms();
    initGoogleMaps();

    if (!motionModulePromise) {
        import('./motion/anchor-links.js').then(({ initAnchorLinks }) => {
            initAnchorLinks({ lenis: null });
        });
        return;
    }

    motionModulePromise.then(({ bootMotion }) => {
        bootMotion();
    });
});
